module.exports = __webpack_public_path__ + "fonts/line_10.svg";